import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { ICustomButtonProps } from "./ICustomButtonProps";

interface IPhoneProps extends Omit<ICustomButtonProps, "onClick"> {
  phone: string;
  noText?: boolean;
}

export const PhoneButton: React.FunctionComponent<IPhoneProps> = ({
  minimal = true,
  phone,
  loading,
  disabled,
  intent = Intent.NONE,
  noText = false,
}) => {
  const onClickPhone = React.useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const el = document.createElement("a");
      el.setAttribute("href", `tel:${phone}`);
      el.click();
    },
    [phone]
  );

  return (
    <Button
      title={phone}
      intent={intent}
      disabled={disabled}
      icon={IconNames.PHONE}
      minimal={minimal}
      loading={loading}
      onClick={onClickPhone}
      text={noText ? null : phone}
    />
  );
};
